export default __webpack_public_path__ + "static/media/triviaicon.5653d789.svg";